import {DateTime, IANAZone} from 'luxon'

export const APPLICATION_TIMEZONE = 'Europe/Bratislava'

export const convertTimezone = (
  date: Date,
  sourceTimezone: string,
  destTimezone: string,
): DateTime => {
  const sourceDate = DateTime.fromJSDate(date, {zone: sourceTimezone})
  return sourceDate.setZone(destTimezone)
}

export const getTimezoneFullname = (timezone: string) => {
  const dt = DateTime.now().setZone(timezone)
  const offsetFormatted = dt.toFormat('ZZ') // e.g. "+02:00"
  return `UTC${offsetFormatted}, ${timezone.replace(/_/g, ' ')}`
}

export const getOrderedTimezoneChoices = (): Array<{id: string; name: string; offset: number}> => {
  const timezones = Intl.supportedValuesOf('timeZone').filter(
    (timezone) => IANAZone.isValidSpecifier(timezone) && IANAZone.create(timezone).isValid,
  )

  return timezones
    .map((timezone) => ({
      id: timezone,
      name: getTimezoneFullname(timezone),
      offset: DateTime.now().setZone(timezone).offset, // e.g. 120 (minutes),
    }))
    .sort((a, b) => {
      // Primary: sort by offset (UTC-12 first, UTC+14 last)
      if (a.offset !== b.offset) {
        return a.offset - b.offset
      }
      // Secondary: alphabetical within the same offset
      return a.name.localeCompare(b.name)
    })
}
